import {
  LOADING_ACTIVE_TIMELINE,
  LOADING_ACTIVE_TIMELINE_FAILED,
  LOADING_ACTIVE_TIMELINE_SUCCESS,
  LOADING_ACTIVE_USER,
  LOADING_ACTIVE_USER_FAILED,
  LOADING_ACTIVE_USER_SUCCESS,
  CREATE_BULK_INCIDENT,
  LOADING_BULK_INCIDENT,
  LOADING_ACTIVE_TIMELINE_TEST,
  LOADING_ACTIVE_USER_INCIDENTTEST,
} from 'actions/reports';
import {
  getActiveTimeline,
  getActiveUser,
  postCreateReportBulkIncident,
  getReportBulkIncident,
  getActiveTimelineTest,
  getActiveUserIncidentTest,
} from 'api/reports';
import {
  IActionLoadingReportActiveTimeline,
  IActionLoadingReportActiveUsers,
  IActionCreateReportBulkIncident,
  IActionGetReportBulkIncident,
} from 'pages/reports/interfaces';
import { call, put, takeLatest } from 'redux-saga/effects';
import { OK } from 'utils';

function* loadingActiveUsers({ payload }: IActionLoadingReportActiveUsers) {
  try {
    const get = yield call(getActiveUser, payload.query);

    if (get?.status === OK) {
      const { data } = get;

      const newData = Array.isArray(data) ? data : [data];

      const newActiveUsers: any[] = newData.map((organization: any) => {
        let newSchools: any = [];

        if (organization.childrens?.length) {
          newSchools = organization.childrens.map((school: any) => {
            let newGrades: any = [];

            if (school.childrens?.length) {
              newGrades = school.childrens.map((grade: any) => {
                return {
                  ...grade,
                  isGrade: true,
                };
              });
            }

            return {
              ...school,
              isSchool: true,
              children: newGrades,
            };
          });
        }

        return {
          ...organization,
          isOrg: true,
          children: newSchools,
        };
      });

      yield put({ type: LOADING_ACTIVE_USER_SUCCESS });

      if (payload?.onSuccess) yield payload.onSuccess(newActiveUsers);
    } else {
      yield put({ type: LOADING_ACTIVE_USER_FAILED });
      if (payload?.onError) yield payload.onError();
    }
  } catch (error) {
    console.log('🚀 ~ error', error);
    yield put({ type: LOADING_ACTIVE_USER_FAILED });
    if (payload?.onError) yield payload.onError();
  }
}

function* loadingActiveUsersIncidentTest({ payload }: IActionLoadingReportActiveUsers) {
  try {
    const get = yield call(getActiveUserIncidentTest, payload.query);

    if (get?.status === OK) {
      const { data } = get;

      const newData = Array.isArray(data) ? data : [data];

      const newActiveUsers: any[] = newData.map((organization: any) => {
        let newSchools: any = [];

        if (organization.childrens?.length) {
          newSchools = organization.childrens.map((school: any) => {
            let newGrades: any = [];

            if (school.childrens?.length) {
              newGrades = school.childrens.map((grade: any) => {
                return {
                  ...grade,
                  isGrade: true,
                };
              });
            }

            return {
              ...school,
              isSchool: true,
              children: newGrades,
            };
          });
        }

        return {
          ...organization,
          isOrg: true,
          children: newSchools,
        };
      });

      yield put({ type: LOADING_ACTIVE_USER_SUCCESS });

      if (payload?.onSuccess) yield payload.onSuccess(newActiveUsers);
    } else {
      yield put({ type: LOADING_ACTIVE_USER_FAILED });
      if (payload?.onError) yield payload.onError();
    }
  } catch (error) {
    console.log('🚀 ~ error', error);
    yield put({ type: LOADING_ACTIVE_USER_FAILED });
    if (payload?.onError) yield payload.onError();
  }
}

function* loadingActiveTimeline({ payload }: IActionLoadingReportActiveTimeline) {
  try {
    const get = yield call(getActiveTimeline, payload.query);

    if (get?.status === OK) {
      yield put({ type: LOADING_ACTIVE_TIMELINE_SUCCESS });

      if (payload?.onSuccess) yield payload.onSuccess(get?.data);
    } else {
      yield put({ type: LOADING_ACTIVE_TIMELINE_FAILED });
      if (payload?.onError) yield payload.onError(get?.error_code);
    }
  } catch (error) {
    console.log('🚀 ~ error', error);
    yield put({ type: LOADING_ACTIVE_TIMELINE_FAILED });
    if (payload?.onError) yield payload.onError('');
  }
}

function* loadingActiveTimelineTest({ payload }: IActionLoadingReportActiveTimeline) {
  try {
    const get = yield call(getActiveTimelineTest, payload.query);

    if (get?.status === OK) {
      yield put({ type: LOADING_ACTIVE_TIMELINE_SUCCESS });

      if (payload?.onSuccess) yield payload.onSuccess(get?.data);
    } else {
      yield put({ type: LOADING_ACTIVE_TIMELINE_FAILED });
      if (payload?.onError) yield payload.onError(get?.error_code);
    }
  } catch (error) {
    console.log('🚀 ~ error', error);
    yield put({ type: LOADING_ACTIVE_TIMELINE_FAILED });
    if (payload?.onError) yield payload.onError('');
  }
}

function* loadingBulkIncident({ payload }: IActionGetReportBulkIncident) {
  try {
    const get = yield call(getReportBulkIncident, payload.query);
    payload?.onSuccess?.(get);
  } catch (error) {
    console.log('🚀 ~ error', error);
    if (payload?.onError) yield payload.onError();
  }
}

function* createBulkIncident({ payload }: IActionCreateReportBulkIncident) {
  try {
    const get = yield call(postCreateReportBulkIncident, payload.query);
    payload.onSuccess?.(get);
  } catch (error) {
    console.log('🚀 ~ error', error);
    if (payload?.onError) yield payload.onError(error);
  }
}

export default function* reportsSaga() {
  yield takeLatest(LOADING_ACTIVE_USER, loadingActiveUsers);
  yield takeLatest(LOADING_ACTIVE_USER_INCIDENTTEST, loadingActiveUsersIncidentTest);
  yield takeLatest(LOADING_ACTIVE_TIMELINE, loadingActiveTimeline);
  yield takeLatest(LOADING_ACTIVE_TIMELINE_TEST, loadingActiveTimelineTest);
  yield takeLatest(CREATE_BULK_INCIDENT, createBulkIncident);
  yield takeLatest(LOADING_BULK_INCIDENT, loadingBulkIncident);
}
